import { ComponentType, ReactElement, ReactNode } from "react"

/**
 * A page component plus its optional per-page layout. Historically extended
 * Next's `NextPage`; in the Vite + React Router SPA a page is just a React
 * component, so the base is `ComponentType`. The `getLayout` static is applied
 * by {@link getAppLayout} in the route table, preserving the `_app` behaviour.
 */
export type NextPageWithLayout<P = {}> = ComponentType<P> & {
  getLayout?: (page: ReactElement) => ReactNode
}

export function getAppLayout(Component: NextPageWithLayout, page: ReactElement): ReactNode {
  const getLayout = Component.getLayout || ((page) => page)
  return getLayout(page)
}
